<template>
  <DeleteConfirm
      itemKey="TicketShare"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketShares from '@/services/ticket-shares'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketShares
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť podiel "' + Item.User.name + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť podiel "' + Item.User.name + '"?'
      },
      deleteData() {
        return TicketShares
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
